export default __webpack_public_path__ + "static/media/positive.d2f94231.png";